import React, {useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import Grid from "@material-ui/core/Grid";
import Button from "../../../../UI/Button/Button";
import {Popover} from "@material-ui/core";
import classes from "./Clients.module.css";
import {translation} from "../../../../../I18n/i18n";
import SpellChecker from "../../../../UI/SpellChecker/SpellChecker";

const NewClientElement = (props) => {

    let [clientName, setClientName] = useState ("");

    let onCloseHandler = () => {
        setClientName ("");
        props.hidePopup ();
    };

    let addClient = () => {
        props.onSubmit (clientName);
    }

    return (
        <Popover
            id={ `client-Popup` }
            open={ props.isOpenPopup }
            anchorEl={ props.popupLauncher }
            onClose={ onCloseHandler }
            anchorOrigin={ {
                vertical: 'bottom',
                horizontal: 'center',
            } }
            transformOrigin={ {
                vertical: 'top',
                horizontal: 'center',
            } }
        >
            <div className="popoverStyle">
                <div><h1 className="popoverTitle">{ translation (props.lang, "Add new Client") }</h1></div>
                <br/>
                <div>
                    <Form onSubmit={ e => {
                        e.preventDefault ()
                    } }>
                        <Form.Group as={ Row }>
                            <Form.Label column sm="3">
                                { translation (props.lang, "Name") }
                                <span className={ classes.required }>*</span>
                            </Form.Label>
                            <Col sm="9">
                                <SpellChecker
                                    dict={props.dict}
                                    addToDictionary={ props.addToDictionary }
                                    notify={ props.notify }
                                    lang={props.lang}
                                    value={ clientName }
                                    onChange={ setClientName }
                                    isInvalid={ containsAnyOf (clientName, `"*:<>?/|\\`) }
                                    feedback={ `${ translation(props.lang, "Enter a name that does not contain any of these characters")} " * : < > ? / | \\` }
                                />
                            </Col>
                        </Form.Group>
                    </Form>
                </div>
                <br/>
                <Grid container>
                    <Grid item xs={ 3 } style={ {padding: '0 2px 0 0'} }>
                        <Button
                            lang={ props.lang }
                            label={ "Confirm" }
                            variant={ "success" }
                            isDisabled={ !clientName || containsAnyOf (clientName, `"*:<>?/|\\`) }
                            actionHandler={ () => addClient () }
                            size="sm"
                            isVisible={ true }
                        />

                    </Grid>
                    <Grid item xs={ 3 } style={ {padding: '0 0 0 2px'} }>
                        <Button
                            lang={ props.lang }
                            isVisible={ true }
                            label={ "Cancel" }
                            variant={ "danger" }
                            actionHandler={ onCloseHandler }
                            size="sm"
                        />
                    </Grid>
                    <Grid item xs={ 6 }/>
                </Grid>
            </div>

        </Popover>

    );
}

export default NewClientElement;

let containsAnyOf = (text, unwanted) => {
    return text.split ("").some (c => unwanted.indexOf (c) !== -1);
}